import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_MARRAKECH_ESSAOUIRA } from "@/lib/itineraryHubs";
export default function MarrakechEssaouiraHubPage() {
  return <ItineraryHubPage hub={HUB_MARRAKECH_ESSAOUIRA} />;
}
